import React from "react";
import ReactMarkdown from "react-markdown";

/**
 * Renders a markdown string safely as React elements.
 *
 * react-markdown v8 never executes raw HTML by default (HTML tags are
 * rendered as escaped text), so no dangerouslySetInnerHTML is involved
 * and XSS is not possible without explicitly opting in via rehype-raw.
 */
const MarkdownRenderer = ({ content, emptyLabel = "Pas d'information" }) => {
  if (!content?.trim()) {
    return <span className="text-muted fst-italic">{emptyLabel}</span>;
  }

  return (
    <div className="markdown-content">
      <ReactMarkdown>{content}</ReactMarkdown>
    </div>
  );
};

export default MarkdownRenderer;
